var _ellipse, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _ellipse2, _ellipse3, _path22, _path23, _path24, _path25, _path26, _polygon, _path27, _path28, _path29, _polygon2, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _ellipse4, _path38, _path39, _path40, _path41, _path42, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _path43, _path44, _path45, _path46, _path47, _path48;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_340_web_developer_flatline",
    "data-name": "#340_web_developer_flatline",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 170.24,
    cy: 252.92,
    rx: 89.05,
    ry: 7.27,
    fill: "#e6e7e8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 255.49,
    y: 184.67,
    width: 63.32,
    height: 51.59,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M318.81,236.77H255.49a.5.5,0,0,1-.5-.5v-51.6a.5.5,0,0,1,.5-.5h63.32a.51.51,0,0,1,.5.5v51.6A.51.51,0,0,1,318.81,236.77Zm-62.82-1h62.32v-50.6H256Z",
    fill: "#d1d3d4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M318.81,191.8H255.49a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h63.32a.5.5,0,0,1,.5.5A.51.51,0,0,1,318.81,191.8Z",
    fill: "#d1d3d4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M144.34,88.28a7,7,0,0,1-5.86-11.45c-3.82-1.76-5.84-6.28-5.56-10.47s2.49-8,5.25-11.22c2.27-2.63,5.12-5,8.53-5.65a5.6,5.6,0,0,0,1.86-.52,4.77,4.77,0,0,0,1.18-1.19c2.49-3.18,5.56-6.1,9.4-7.38s8.54-.55,11.11,2.58a8.4,8.4,0,0,1,13.84,7.4,14.47,14.47,0,0,1,11.72,10.07c1.43,5.26-1,11.44-5.85,13.93-.56.29-1.23.67-1.21,1.29a1.87,1.87,0,0,0,.48,1c1.56,2.23.78,5.46-1,7.48s-4.44,3.09-7,4.11A3.92,3.92,0,0,1,182,92.7a8.36,8.36,0,0,1-3.32,3.48c-5.56,3.59-12.44,2.47-18.67,2.6-5.75.12-11.46-3.55-15.27-7.71C144,90.28,143.41,88.84,144.34,88.28Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M166.9,99.35c-1,0-2,0-2.92,0-1.3,0-2.66-.06-3.94,0-5.22.09-11-2.84-15.66-7.87a3.43,3.43,0,0,1-1-2.51.36.36,0,0,1,0-.11A7.46,7.46,0,0,1,137.72,77c-3.45-1.9-5.6-6.19-5.3-10.67.25-3.83,2.06-7.7,5.37-11.52,2.88-3.32,5.76-5.22,8.82-5.81l.34-.06a2.86,2.86,0,0,0,2.36-1.42c3.14-4,6.29-6.46,9.67-7.59,4.17-1.39,8.74-.42,11.33,2.35A8.91,8.91,0,0,1,184.64,50,15,15,0,0,1,196.3,60.32c1.52,5.59-1.17,12-6.11,14.51-.5.25-.95.53-.94.83a1.31,1.31,0,0,0,.29.56l.09.13c1.78,2.52.77,6.05-1.08,8.09a17.28,17.28,0,0,1-6.46,4,4.66,4.66,0,0,1,.38,4.49A8.64,8.64,0,0,1,179,96.6C175.29,99,171.09,99.35,166.9,99.35Zm-5.75-1.08c.95,0,1.91,0,2.85,0,5,.1,10.15.21,14.42-2.55a7.71,7.71,0,0,0,3.13-3.26,3.41,3.41,0,0,0-.65-3.9.5.5,0,0,1-.17-.46.51.51,0,0,1,.31-.39c2.34-.94,5-2,6.77-4,1.59-1.75,2.48-4.75,1-6.85l-.09-.11a2,2,0,0,1-.48-1.12c0-1,.95-1.48,1.48-1.75,4.54-2.34,7-8.2,5.6-13.36A14,14,0,0,0,184,50.88a.5.5,0,0,1-.42-.56,7.92,7.92,0,0,0-13-7,.49.49,0,0,1-.37.12.48.48,0,0,1-.34-.18c-2.25-2.74-6.6-3.74-10.56-2.41-3.19,1.06-6.19,3.42-9.17,7.21a5.1,5.1,0,0,1-1.31,1.31,4.65,4.65,0,0,1-1.7.52l-.32.06c-2.83.55-5.53,2.34-8.26,5.48-3.16,3.65-4.88,7.33-5.12,10.93-.29,4.32,1.87,8.42,5.27,10a.51.51,0,0,1,.28.34.5.5,0,0,1-.11.43,6.47,6.47,0,0,0,5.44,10.63.49.49,0,0,1,.52.35.5.5,0,0,1-.22.58.43.43,0,0,0-.22.34,2.45,2.45,0,0,0,.74,1.69c4.42,4.82,10,7.64,14.89,7.54Z",
    fill: "#231f20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M215.76,234.73c2.29,0,19.36,1.85,27.35,5.82s9.72,4.28,8.1,9.64-15.69,6.68-26.4,4.66a72.26,72.26,0,0,1-19.75-7.18Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M234.91,256.28a54.49,54.49,0,0,1-10.18-1,73.08,73.08,0,0,1-19.89-7.22.5.5,0,0,1-.23-.32.45.45,0,0,1,.1-.37l10.7-12.94a.42.42,0,0,1,.34-.17h.1c2.79,0,19.46,1.9,27.46,5.87l1.8.89c6.41,3.14,8.14,4,6.54,9.3C250.64,253.68,244.06,256.28,234.91,256.28Zm-29.14-8.75a72.34,72.34,0,0,0,19.13,6.87c10.75,2,24.39.58,25.88-4.34,1.37-4.56.38-5.05-6.07-8.21l-1.8-.89c-7.63-3.79-23.95-5.72-26.94-5.78Z",
    fill: "#231f20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M218.05,234.68a6.16,6.16,0,0,1,4.61,7c-.75,5.69-12.78,5.93-13.47,6S218.05,234.68,218.05,234.68Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M209.19,248a.53.53,0,0,1-.44-.26c-.15-.3-.39-.76,8.93-13.37a.45.45,0,0,1,.48-.17c.05,0,5.75,1.43,5,7.46-.76,5.79-11.72,6.3-13.91,6.34Zm9-12.83c-2.93,4-7.29,10-8.38,11.9,2.74-.13,11.75-.9,12.36-5.53A5.6,5.6,0,0,0,218.23,235.21Z",
    fill: "#231f20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M128.89,247.71c-.35.18-3.62,4.43-17.88,6.13s-19.55,4.77-22.73-2.72-1-12.33,6-14.47,26.39-3.91,30.19-.33S128.89,247.71,128.89,247.71Z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M95.32,256.38c-3.53,0-5.8-1.18-7.46-5.08s-1.91-7.25-.7-9.84c1.12-2.4,3.48-4.17,7-5.24,6.58-2,26.57-4.06,30.63-.23,3.89,3.66,4.51,11.36,4.54,11.68a.48.48,0,0,1-.22.43l-.14.12c-4.11,3.74-12,5.37-17.92,6.07-3.07.37-5.71.8-8,1.18A52.64,52.64,0,0,1,95.32,256.38Zm18.46-21.66c-6.85,0-15.15,1.09-19.33,2.37-3.28,1-5.46,2.6-6.46,4.76-1.1,2.34-.86,5.4.71,9.09,2.35,5.55,5.82,5,14.18,3.63,2.34-.38,5-.81,8.08-1.18,5.78-.69,13.49-2.27,17.42-5.85l0,0c-.14-1.31-1-7.78-4.23-10.86C122.71,235.26,118.6,234.72,113.78,234.72Z",
    fill: "#231f20"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M133.44,244.65s-6.47,5.4-10.78,4.76-10.27-3-7.87-7.65,17.85-7.45,17.85-7.45Z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M123.4,249.92a5.42,5.42,0,0,1-.81-.06c-3.23-.48-7.13-1.86-8.38-4.31a4.18,4.18,0,0,1,.17-4c2.48-4.82,17.54-7.57,18.18-7.69a.46.46,0,0,1,.36.09.48.48,0,0,1,.18.33l.8,10.33a.47.47,0,0,1-.16.39C133.48,245.21,127.79,249.92,123.4,249.92Zm8.83-15.06c-2.65.52-15,3.15-17,7.11a3.29,3.29,0,0,0-.18,3.17c1.1,2.13,4.7,3.37,7.71,3.82,3.67.55,9.18-3.67,10.24-4.51Z",
    fill: "#231f20"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M211.16,199.29s-6.82,26.6-31.71,31.68-37.77,3.74-46.59-13.06-3-27.08-3-27.08l78.55-1.56Z",
    fill: "#231f20"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M158.92,234.08c-12,0-20.33-4.18-26.51-15.94-8.84-16.85-3.21-27.13-3-27.56a.5.5,0,0,1,.43-.25l78.55-1.56a.49.49,0,0,1,.5.37l2.72,10a.57.57,0,0,1,0,.26c-.07.27-7.18,27-32.1,32.05C171.64,233.08,164.83,234.08,158.92,234.08Zm-28.73-42.76c-.78,1.65-4.72,11.43,3.11,26.36,8.95,17,22,17.72,46,12.8,23.43-4.78,30.74-29.23,31.29-31.19l-2.59-9.51Z",
    fill: "#231f20"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M124,199.53s-12.87-41.6-11.18-67.67,11.38-27,24.6-28.47c5.87-.66,37.14-5.29,48.85,8.49s32.32,78.32,32.32,78.32Z",
    fill: "#9db0ef"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M170.45,103.46l-2,13.92s-4.38,7.19-13.15,3.55-8.94-10.35-8.94-10.35l4.16-25.72s9.25-8.3,13.14-24.16c0,0,7.75,13.52,19,16.56,0,0-.75,11.23-2.76,18.19C177.9,102.18,170.59,103.38,170.45,103.46Z",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M160,122.45a12.76,12.76,0,0,1-4.94-1.06c-9-3.72-9.24-10.51-9.25-10.8L150,84.78a.55.55,0,0,1,.16-.3c.09-.08,9.18-8.38,13-23.9a.52.52,0,0,1,.42-.37.5.5,0,0,1,.5.24c.08.14,7.79,13.38,18.68,16.32a.5.5,0,0,1,.37.52c0,.11-.78,11.37-2.78,18.3-1.65,5.71-7,7.67-9.44,8.27l-2,13.59a.6.6,0,0,1-.06.19A11,11,0,0,1,160,122.45ZM151,85.1l-4.14,25.56c0,.16.3,6.34,8.64,9.81,7.79,3.23,12-2.52,12.48-3.27l2-13.81a.47.47,0,0,1,.25-.36.78.78,0,0,1,.3-.1c2.15-.51,7.33-2.28,8.87-7.62,1.76-6.09,2.56-15.61,2.71-17.68-9.4-2.76-16.22-12.45-18.26-15.66C160.05,76.05,152.08,84,151,85.1Zm17.46,32.28h0Z",
    fill: "#231f20"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M155.91,85.25a6,6,0,0,0-1.52-3.5,10.51,10.51,0,0,0-2.94-2.12,4.55,4.55,0,0,0-1.87-.65,3.8,3.8,0,0,0-1.37.27,4.68,4.68,0,0,0-2.56,2,5.45,5.45,0,0,0-.53,2.59,11.08,11.08,0,0,0,.26,2.88,7.3,7.3,0,0,0,9,5.28",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M152.48,92.71a7.81,7.81,0,0,1-7.58-5.9,10.89,10.89,0,0,1-.28-3,6,6,0,0,1,.59-2.82A5.14,5.14,0,0,1,148,78.78a4.42,4.42,0,0,1,1.56-.3,5,5,0,0,1,2.09.71,11.07,11.07,0,0,1,3.07,2.22,6.52,6.52,0,0,1,1.65,3.8.51.51,0,0,1-.46.54.52.52,0,0,1-.54-.46A5.53,5.53,0,0,0,154,82.08a9.93,9.93,0,0,0-2.81-2,4,4,0,0,0-1.65-.6,3.15,3.15,0,0,0-1.18.24,4.25,4.25,0,0,0-2.3,1.73,5.09,5.09,0,0,0-.46,2.36,9.72,9.72,0,0,0,.25,2.75,6.81,6.81,0,0,0,8.36,4.92.5.5,0,0,1,.61.35.5.5,0,0,1-.36.61A7.48,7.48,0,0,1,152.48,92.71Z",
    fill: "#231f20"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M168.48,81.28s3.93,7.75,2.64,8.86-4.39-.11-4.39-.11",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M169.51,91.11a9.06,9.06,0,0,1-3-.61.5.5,0,0,1-.28-.65.51.51,0,0,1,.65-.28c.73.28,3,.93,3.87.19.53-.44-.79-4.38-2.75-8.26a.49.49,0,0,1,.22-.67.51.51,0,0,1,.67.22c1.23,2.44,3.95,8.24,2.52,9.47A3,3,0,0,1,169.51,91.11Z",
    fill: "#231f20"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.41,
    cy: 79.44,
    rx: 1.68,
    ry: 1.2,
    transform: "translate(70.03 234.85) rotate(-85.34)",
    fill: "#231f20"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.8,
    cy: 81.15,
    rx: 1.68,
    ry: 1.2,
    transform: "translate(80.88 249.44) rotate(-85.74)",
    fill: "#231f20"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M167.46,97.31a9.49,9.49,0,0,1-4.41-1c-2.39-1.25-3.92-3.64-4.55-7.1a.5.5,0,0,1,.41-.58.51.51,0,0,1,.58.4c.56,3.14,1.92,5.29,4,6.39,4.2,2.2,10.11-.46,10.17-.49a.5.5,0,0,1,.66.25.49.49,0,0,1-.25.66A17.74,17.74,0,0,1,167.46,97.31Z",
    fill: "#231f20"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M170.45,103.46s-9,.74-13.64-2.92c0,0,3.95,12.5,12.25,12.46Z",
    fill: "#231f20"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M169,113.5c-8.54,0-12.52-12.29-12.69-12.81a.51.51,0,0,1,.2-.56.48.48,0,0,1,.59,0c4.47,3.49,13.2,2.82,13.29,2.81a.5.5,0,0,1,.53.57l-1.39,9.55A.53.53,0,0,1,169,113.5Zm-11.2-11.7c1.27,3.13,4.87,10.38,10.81,10.69l1.23-8.49C167.92,104.08,162,104.14,157.82,101.8Z",
    fill: "#231f20"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M127.51,105.71c-18.47-2.3-35.81,76.11-25.73,83.56,15.72,11.63,63.7-4.25,63.7-4.25l-4.8-20.69s-34.63,1.65-35.26-5.46,19.35-40.44,16.55-45.3S127.51,105.71,127.51,105.71Z",
    fill: "#9db0ef"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M192,164.91a.44.44,0,0,1-.45-.39c-2.38-16.72-7.6-44.72-9.29-46.36a.46.46,0,0,1,.64-.66c2.17,2.11,7.75,34.23,9.55,46.89a.46.46,0,0,1-.39.52Z",
    fill: "#231f20"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "174.33 204.47 142.45 195.54 201 184.53 232.69 197.81 174.33 204.47",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M174.33,205a.3.3,0,0,1-.13,0L142.32,196a.5.5,0,0,1,0-1l58.55-11a.45.45,0,0,1,.28,0l31.69,13.28a.5.5,0,0,1,.3.53.5.5,0,0,1-.44.43L174.39,205Zm-29.68-9.33L174.37,204l56.36-6.43-29.79-12.48Z",
    fill: "#231f20"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M155.52,171.48c7,.77,13.49,1.27,20,4a49.08,49.08,0,0,1,10.46,6,33.69,33.69,0,0,1,4.59,3.92c1.12,1.22.76,2.41-1.12,1.82a22.73,22.73,0,0,1-6.14-3,65.14,65.14,0,0,1,11.87,12.67c.38.54.75,1.31.3,1.79s-1.45,0-2-.5l-9.89-9.38a31.37,31.37,0,0,1,6.59,7.92c.25.43.49,1,.23,1.39-.44.73-1.56.18-2.16-.43a71.83,71.83,0,0,1-8.05-9.7l5.34,8a1.18,1.18,0,0,1-1.51.73,3.43,3.43,0,0,1-1.47-1.16l-6.47-7.43,3.82,5.26c.6.82,1.2,2,.51,2.77s-2.25,0-3.13-.78a64.78,64.78,0,0,0-11.59-8.43c-1.51-.89-2.8-2.1-4.47-2.61-2.4-.74-5.4-.64-7.9-.92",
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M195,199.36a2.92,2.92,0,0,1-1.76-.86l-3.2-3c.21.33.42.67.61,1a1.83,1.83,0,0,1,.23,1.86,1.14,1.14,0,0,1-.86.56,2.73,2.73,0,0,1-2-.91c-.66-.66-1.3-1.33-1.93-2a.45.45,0,0,1,0,.11,1.34,1.34,0,0,1-.64.89,1.84,1.84,0,0,1-1.45.19,3.78,3.78,0,0,1-1.68-1.3l-1.18-1.35a1.89,1.89,0,0,1-.28,2,1.59,1.59,0,0,1-1.14.53A4.32,4.32,0,0,1,177,195.7a62.86,62.86,0,0,0-11.5-8.36c-.51-.3-1-.64-1.48-1a10.58,10.58,0,0,0-2.89-1.6,23.73,23.73,0,0,0-5.33-.72c-.86-.05-1.7-.1-2.49-.18a.46.46,0,0,1-.4-.51.45.45,0,0,1,.5-.4c.78.08,1.6.13,2.44.18a24.36,24.36,0,0,1,5.55.75,11.93,11.93,0,0,1,3.14,1.72c.46.33.93.65,1.42.94A64.73,64.73,0,0,1,177.63,195a3.7,3.7,0,0,0,2,1.05.69.69,0,0,0,.49-.23c.54-.59-.2-1.74-.54-2.21l-3.82-5.25a.44.44,0,0,1,.08-.62.45.45,0,0,1,.63,0l6.48,7.43a2.94,2.94,0,0,0,1.25,1,.92.92,0,0,0,.71-.09.45.45,0,0,0,.16-.14l-5.21-7.83a.45.45,0,0,1,.75-.51,72.39,72.39,0,0,0,8,9.64,2,2,0,0,0,1.25.64.22.22,0,0,0,.19-.12c.11-.17,0-.49-.23-.93a30.72,30.72,0,0,0-4.29-5.7l-2.23-2.12a.46.46,0,0,1,.62-.67c.79.68,1.54,1.39,2.26,2.14l7.64,7.25a1.88,1.88,0,0,0,1.15.62.25.25,0,0,0,.21-.1c.23-.24,0-.78-.33-1.22a64.78,64.78,0,0,0-11.78-12.58.46.46,0,0,1,.55-.73,22,22,0,0,0,6,2.94c.7.22,1.07.13,1.14,0s0-.57-.49-1.09a32.21,32.21,0,0,0-4.53-3.86,48.35,48.35,0,0,0-10.36-5.93c-5.87-2.45-11.74-3.08-18-3.75l-1.95-.22a.45.45,0,0,1-.4-.5.45.45,0,0,1,.5-.4l2,.21c6.29.68,12.22,1.32,18.21,3.82a49.11,49.11,0,0,1,10.56,6,33.78,33.78,0,0,1,4.66,4c.72.78.94,1.63.58,2.2-.21.32-.77.8-2.18.36a21.32,21.32,0,0,1-2.39-.89,65.86,65.86,0,0,1,8.63,9.86c.69,1,.78,1.81.27,2.37a1.19,1.19,0,0,1-.86.39Z",
    fill: "#231f20"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "232.69 197.81 247.28 158.76 187.69 159.94 174.33 204.47 232.69 197.81",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M174.33,205a.48.48,0,0,1-.38-.18.51.51,0,0,1-.1-.46l13.36-44.53a.52.52,0,0,1,.47-.36l59.59-1.18a.51.51,0,0,1,.42.21.54.54,0,0,1,.06.46l-14.59,39a.51.51,0,0,1-.42.33L174.39,205Zm13.74-44.54-13,43.46,57.3-6.54,14.22-38.08Zm44.62,37.38h0Z",
    fill: "#231f20"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M229.51,198.17S245.68,211.3,240,223.34,131,249.14,131,249.14l-4.65-15.74S207.4,192,229.51,198.17Z",
    fill: "#231f20"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M131,249.64a.51.51,0,0,1-.48-.36l-4.65-15.74a.48.48,0,0,1,.25-.58c.2-.11,20.53-10.46,43.31-19.94,30.65-12.75,50.9-17.91,60.18-15.33a.5.5,0,0,1,.19.1,43.84,43.84,0,0,1,7.46,8.17c4.46,6.42,5.54,12.5,3.12,17.6-5.78,12.14-105.09,25.51-109.31,26.07Zm-4.06-16,4.42,14.92c7.22-1,102.75-14.18,108.12-25.45,5.28-11.12-9-23.49-10.24-24.5C208.22,193,133,230.64,127,233.66Z",
    fill: "#231f20"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M121,192.14s80.23,32.44,100.12,41L209.56,251s-74.08-1.45-95.32-20.06S94.41,181.35,121,192.14Z",
    fill: "#231f20"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M209.56,251.52h0c-.18,0-18.79-.39-39.75-3.05-28.2-3.59-47-9.35-55.89-17.14-11.12-9.74-18.91-26.84-12.79-36.77,2-3.3,7.34-8.05,20.08-2.89h0c.8.33,80.46,32.55,100.13,41a.48.48,0,0,1,.28.31.52.52,0,0,1-.06.42L210,251.29A.5.5,0,0,1,209.56,251.52ZM111.15,190.4c-4.11,0-7.26,1.58-9.18,4.68-4.72,7.67-.79,23.77,12.6,35.5,20.21,17.71,89.73,19.81,94.72,19.93l11.1-17.15c-20.54-8.8-98.77-40.44-99.57-40.76h0A26.24,26.24,0,0,0,111.15,190.4Z",
    fill: "#231f20"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M233,182.22a2.84,2.84,0,0,0,.58,1.26l1.56,2.33a1.69,1.69,0,0,0-2.32-1.16,2.73,2.73,0,0,0-1.43,2.47,7.86,7.86,0,0,0,.7,2.91c1.11,2.88,3.62,7.09,7.25,4.91,2.46-1.48,3.14-6.7,3.49-9.3.69-5.12-.88-11.7-7.46-10.7a12.66,12.66,0,0,0,2.7,6.91C237,180.81,232.67,179.2,233,182.22Z",
    fill: "#fff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M237.33,196a3.44,3.44,0,0,1-1.18-.2c-2.37-.81-3.85-3.86-4.52-5.61a8.4,8.4,0,0,1-.73-3.08,3.12,3.12,0,0,1,1.71-2.87,1.89,1.89,0,0,1,.78-.17l-.22-.33a3.25,3.25,0,0,1-.66-1.48,1.82,1.82,0,0,1,1-2,4.26,4.26,0,0,1,3.1.23,13,13,0,0,1-1.68-5.48.47.47,0,0,1,.39-.49,6.32,6.32,0,0,1,5.67,1.56c2.35,2.32,2.74,6.5,2.31,9.65-.39,2.88-1.09,8.05-3.71,9.63A4.23,4.23,0,0,1,237.33,196Zm-3.88-11a1.19,1.19,0,0,0-.47.09,2.27,2.27,0,0,0-1.16,2.06,7.28,7.28,0,0,0,.66,2.74c.5,1.28,1.88,4.35,4,5.07a3,3,0,0,0,2.62-.39c2.25-1.35,2.93-6.43,3.26-8.87.41-3,.08-6.9-2-9a5.29,5.29,0,0,0-4.47-1.37,12.25,12.25,0,0,0,2.57,6.23.45.45,0,0,1-.05.62.46.46,0,0,1-.63,0c-.67-.66-2.88-1.6-3.87-1.12-.22.1-.5.33-.43,1.11h0a2.71,2.71,0,0,0,.5,1.06l.84,1.24a1.78,1.78,0,0,1,.8,1.29.46.46,0,0,1-.3.48.45.45,0,0,1-.53-.18l-.62-.92A1.43,1.43,0,0,0,233.45,185Z",
    fill: "#231f20"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M210.47,229.44a.63.63,0,0,1-.19,0c-1.75-.68-43.11-16.69-52.43-22.4a.52.52,0,0,1-.17-.71.51.51,0,0,1,.71-.17c9.24,5.66,51.83,22.15,52.26,22.31a.52.52,0,0,1,.3.67A.51.51,0,0,1,210.47,229.44Z",
    fill: "#fff"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.23,
    cy: 148.51,
    rx: 16.51,
    ry: 15.63,
    fill: "#231f20"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M162.23,164.63c-9.38,0-17-7.23-17-16.12s7.63-16.13,17-16.13,17,7.24,17,16.13S171.61,164.63,162.23,164.63Zm0-31.25c-8.83,0-16,6.79-16,15.13s7.18,15.12,16,15.12,16-6.78,16-15.12S171.06,133.38,162.23,133.38Z",
    fill: "#231f20"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M153.52,153.59l-4-2.34v-3.09l4-2.34q2-1.15,4-2.34v3.74c-.71.44-1.42.87-2.13,1.28s-1.41.83-2.13,1.28l2.13,1.18,2.13,1.19v3.78Z",
    fill: "#fff"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M158.65,156.92,163.36,139l2.46,1.11L161.09,158Z",
    fill: "#fff"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M171,145.82l4,2.34v3.09l-4,2.34-4,2.34v-3.78l2.13-1.19,2.13-1.18c-.71-.45-1.42-.88-2.13-1.28s-1.41-.84-2.13-1.28v-3.74Z",
    fill: "#fff"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M128,192a.5.5,0,0,1-.06-1l24-2.91,3.81-19.21L125,166.28a.49.49,0,0,1-.37-.21.48.48,0,0,1-.08-.42l12.64-47.06a.5.5,0,0,1,1,.26l-12.49,46.49,30.67,2.54a.53.53,0,0,1,.36.2.51.51,0,0,1,.09.4l-4,20.11a.51.51,0,0,1-.43.4L128,191.94Z",
    fill: "#231f20"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 210.3,
    y: 56.2,
    width: 49.86,
    height: 5.16,
    fill: "#e6e7e8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 265.96,
    y: 56.2,
    width: 49.86,
    height: 5.16,
    fill: "#e6e7e8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 230.89,
    y: 65.04,
    width: 29.27,
    height: 5.16,
    fill: "#9db0ef"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 265.96,
    y: 65.04,
    width: 44.29,
    height: 5.16,
    fill: "#e6e7e8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 223.27,
    y: 73.89,
    width: 36.89,
    height: 5.16,
    fill: "#e6e7e8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 265.96,
    y: 73.89,
    width: 20.8,
    height: 5.16,
    fill: "#e6e7e8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 238.65,
    y: 82.73,
    width: 21.52,
    height: 5.16,
    fill: "#e6e7e8"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 265.96,
    y: 82.73,
    width: 40.74,
    height: 5.16,
    fill: "#9db0ef"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 253.31,
    y: 91.58,
    width: 6.85,
    height: 5.16,
    fill: "#9db0ef"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 265.96,
    y: 91.58,
    width: 27.37,
    height: 5.16,
    fill: "#e6e7e8"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 213.48,
    y: 127.94,
    width: 45.82,
    height: 5.91,
    fill: "#9db0ef"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 266.66,
    y: 127.94,
    width: 28.14,
    height: 5.91,
    fill: "#e6e7e8"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 222.09,
    y: 138.06,
    width: 37.2,
    height: 5.91,
    fill: "#e6e7e8"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 266.66,
    y: 138.06,
    width: 40.97,
    height: 5.91,
    fill: "#e6e7e8"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 240.69,
    y: 148.19,
    width: 18.6,
    height: 5.91,
    fill: "#e6e7e8"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 266.66,
    y: 148.19,
    width: 48.72,
    height: 5.91,
    fill: "#e6e7e8"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 252.32,
    y: 158.32,
    width: 6.97,
    height: 5.91,
    fill: "#e6e7e8"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 266.66,
    y: 158.32,
    width: 51.78,
    height: 5.91,
    fill: "#9db0ef"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 266.66,
    y: 168.44,
    width: 34.78,
    height: 5.91,
    fill: "#e6e7e8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M284.29,115.12l-3.76-1.5v-2l3.76-1.5,3.76-1.5V111c-.68.29-1.35.56-2,.82s-1.34.53-2,.82l2,.76,2,.76v2.42Z",
    fill: "#e6e7e8"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M289.16,117.25l4.46-11.47,2.34.7L291.47,118Z",
    fill: "#e6e7e8"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M300.82,110.15c1.25.5,2.51,1,3.76,1.5v2l-3.76,1.5-3.76,1.5V114.2l2-.76,2-.76c-.68-.29-1.35-.56-2-.82s-1.34-.53-2-.82v-2.39Z",
    fill: "#e6e7e8"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M211.61,43.9a1.53,1.53,0,0,1,.15-.67,1.57,1.57,0,0,1,.39-.56,1.85,1.85,0,0,1,.57-.36,1.87,1.87,0,0,1,.71-.14,1.75,1.75,0,0,1,.67.14,1.92,1.92,0,0,1,.56.36,1.85,1.85,0,0,1,.38.56,1.67,1.67,0,0,1,.14.67,1.72,1.72,0,0,1-.14.68,1.83,1.83,0,0,1-.38.53,1.86,1.86,0,0,1-1.23.5,1.87,1.87,0,0,1-.71-.14,1.68,1.68,0,0,1-.57-.36,1.55,1.55,0,0,1-.39-.53A1.57,1.57,0,0,1,211.61,43.9Zm0,5.86a1.73,1.73,0,0,1,.54-1.22,1.7,1.7,0,0,1,.57-.37,1.87,1.87,0,0,1,.71-.13,1.74,1.74,0,0,1,.67.13,1.76,1.76,0,0,1,.56.37,1.8,1.8,0,0,1,.38.55,1.7,1.7,0,0,1,0,1.35,1.75,1.75,0,0,1-.38.54,1.92,1.92,0,0,1-.56.36,1.74,1.74,0,0,1-.67.13,1.87,1.87,0,0,1-.71-.13,1.85,1.85,0,0,1-.57-.36,1.5,1.5,0,0,1-.39-.54A1.54,1.54,0,0,1,211.61,49.76Z",
    fill: "#e6e7e8"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M270,212.16a1.77,1.77,0,0,0,1.11-.32c.28-.21.41-.65.41-1.33v-3.1a5.81,5.81,0,0,1,.2-1.52,3.81,3.81,0,0,1,.62-1.28,3.2,3.2,0,0,1,1.08-.88,3.54,3.54,0,0,1,1.6-.33h2.25v3.22h-.79a1,1,0,0,0-.93.44,1.92,1.92,0,0,0-.25,1v3.16a2.91,2.91,0,0,1-.21,1.17,2.69,2.69,0,0,1-.5.78,2.07,2.07,0,0,1-.65.47,1.72,1.72,0,0,1-.63.19v0a2.66,2.66,0,0,1,.63.2,2,2,0,0,1,.65.45,2.76,2.76,0,0,1,.71,1.95v3.17a1.86,1.86,0,0,0,.25,1,1,1,0,0,0,.93.45h.79v3.22h-2.25a3.54,3.54,0,0,1-1.6-.33,3.2,3.2,0,0,1-1.08-.88,3.91,3.91,0,0,1-.62-1.28,5.94,5.94,0,0,1-.2-1.53v-3.1a1.6,1.6,0,0,0-.41-1.32,1.77,1.77,0,0,0-1.11-.32Z",
    fill: "#e6e7e8"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M304.54,215.49a1.8,1.8,0,0,0-1.12.32,1.63,1.63,0,0,0-.41,1.32v3.1a5.94,5.94,0,0,1-.2,1.53,3.72,3.72,0,0,1-.62,1.28,3,3,0,0,1-1.08.88,3.54,3.54,0,0,1-1.6.33h-2.25V221h.8a1,1,0,0,0,.92-.45,1.86,1.86,0,0,0,.25-1v-3.17a2.9,2.9,0,0,1,.21-1.16,2.69,2.69,0,0,1,.51-.79,2,2,0,0,1,.64-.45,2.88,2.88,0,0,1,.64-.2v0a1.82,1.82,0,0,1-.64-.19,2,2,0,0,1-.64-.47,2.51,2.51,0,0,1-.51-.78,2.91,2.91,0,0,1-.21-1.17V208a1.92,1.92,0,0,0-.25-1,1,1,0,0,0-.92-.44h-.8V203.4h2.25a3.54,3.54,0,0,1,1.6.33,3,3,0,0,1,1.08.88,3.63,3.63,0,0,1,.62,1.28,5.81,5.81,0,0,1,.2,1.52v3.1a1.64,1.64,0,0,0,.41,1.33,1.8,1.8,0,0,0,1.12.32Z",
    fill: "#e6e7e8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDesign);
export default __webpack_public_path__ + "static/media/web_design.5c0b6694ad9347ddb96d319d6fa98c0b.svg";
export { ForwardRef as ReactComponent };